import React from 'react';
import clsx from 'clsx';

import Button from './button';
import FormLoadingSpinner from './form-loading-spinner';

import styles from './styles/form.module.scss';

type Props = {
  name?: string;
  className?: string;
  style?: React.CSSProperties;
  submitButtonLabel?: string;
  bottom?: React.ReactNode;
  children: React.ReactNode;
  onSubmit?: (...args: any[]) => any;
  isEmbedded?: boolean;
  isProcessing?: boolean;
  message?: string;
  errorMessage?: string;
};

const Form = ({
  name,
  className,
  style,
  submitButtonLabel,
  bottom,
  children,
  onSubmit,
  isEmbedded,
  isProcessing,
  message,
  errorMessage,
  ...props
}: Props) => (
  <form
    name={name}
    className={clsx(styles.form, className, {
      [styles.standalone]: !isEmbedded
    })}
    style={style}
    onSubmit={(event) => {
      event.preventDefault();
      if (onSubmit) {
        onSubmit(event);
      }
    }}
    {...props}
  >
    {children}
    {message && <div className={styles.message}>{message}</div>}
    {errorMessage && <div className={styles.error}>{errorMessage}</div>}
    {onSubmit && submitButtonLabel && (
      <Button type="submit" isDisabled={isProcessing} style={{width: '100%'}}>
        {submitButtonLabel}
      </Button>
    )}
    {bottom}
    <FormLoadingSpinner isVisible={isProcessing} />
  </form>
);

export default Form;
